<template >
  <section id="detail"
           class="search-detail">

    <div class="search-detail-swiper">
      <div class="swiper-container swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide"
               v-for="(img, indexImg) in (w > 740 ? detail.carImgUrls : detail.carImgUrls)"
               :key="indexImg">
            <!-- {{indexDetail >= (detail.carList.length-3)}} -->
            <div class="lazy"
                 :style="{'background-image': 'url(' + url + img + ')'}"></div>
            <!-- <div class="lazys" v-lazy:background-image="itemDetail.img"></div> -->
          </div>
        </div>
      </div>
      <div class="swiper-button-next iconfontmy icon-enter"
           slot="navigation"></div>
      <div class="swiper-button-prev iconfontmy icon-return"
           slot="navigation"></div>
      <div class="swiper-pagination my-bullet"
           slot="pagination"></div>
    </div>

    <div class="search-detail-data">
      <div class="container">
        <h1>{{locale == 'en' ? detail.carBrandEn + ' ' + detail.carStyleEn + ' ' + detail.year : detail.carBrand + ' ' + detail.carStyleName + ' ' + detail.year}} <strong style="color: #ae0526;"> {{detail.carStatus == 1 ? $t('searchDetail.carStatus')[detail.carStatus].value : ''}}</strong></h1>
        <div class="row">
          <div class="col-md-8 col-lg-8">
            <h4>{{$t('searchDetail.details')}} </h4>
            <ul class="listing-specs">
              <li>
                <span class="spec-key">{{$t('searchDetail.brand')}}：</span>
                <span class="spec-val">{{locale == 'en' || detail.carBrandEn == '' || detail.carBrandEn == null ? detail.carBrandEn : detail.carBrand}}</span>
              </li>
              <li class="spec-min-w300">
                <span class="spec-key">{{$t('searchDetail.manufactureyear')}}：</span>
                <span class="spec-val">{{detail.year}}</span>
              </li>
              <li>
                <span class="spec-key">{{$t('searchDetail.enginecapacity')}}：</span>
                <span class="spec-val">{{locale == 'en' || detail.engineCapacityCn == '' || detail.engineCapacityCn == null ? detail.engineCapacity : detail.engineCapacityCn}} <span class="spec-val-unit">cc</span></span>
              </li>
              <li class="spec-min-w200">
                <span class="spec-key">{{$t('searchDetail.price')}}：</span>
                <span class="spec-val original"
                      style="margin-right: 6px"
                      v-show="detail.originalPrice == null || detail.originalPrice == '' ? false : true">$ {{detail.originalPrice|NumFormatPrice}}
                  <!-- <span class="alt-price" v-popover:popover1> (預估月付額: $ 45,414)</span> -->
                </span>
                <span class="spec-val">$ {{detail.currentPrice|NumFormatPrice}}
                </span>
              </li>
              <li>
                <span class="spec-key">{{$t('searchDetail.fueltype')}}：</span>
                <span class="spec-val">{{locale == 'en' || detail.fuelTypeCn == '' || detail.fuelTypeCn == null ? detail.fuelType : detail.fuelTypeCn}}</span>
              </li>
              <li class="spec-min-w200">
                <span class="spec-key">{{$t('searchDetail.transmission')}}：</span>
                <span class="spec-val">{{locale == 'en' || detail.transmissionCn == '' || detail.transmissionCn == null ? detail.transmission : detail.transmissionCn}}</span>
              </li>
              <li class="spec-min-w300"
                  v-show="detail.engineOutput == '' || detail.engineOutput == null ? false : true">
                <!-- 馬力 -->
                <span class="spec-key">{{$t('searchDetail.engineoutput')}}：</span>
                <span class="spec-val"
                      v-popover:popover2>{{locale == 'en' || detail.engineOutputCn == '' || detail.engineOutputCn == null ? detail.engineOutput : detail.engineOutputCn}} <span class="spec-val-unit"></span><i class="iconfont">&#xe643;</i></span>
              </li>
              <li class="spec-min-w300"
                  v-show="detail.engineTorque == '' || detail.engineTorque == null ? false : true">
                <!-- 扭力 -->
                <span class="spec-key">{{$t('searchDetail.enginetorque')}}：</span>
                <span class="spec-val"
                      v-popover:popover3>{{locale == 'en' || detail.engineTorqueCn == '' || detail.engineTorqueCn == null ? detail.engineTorque : detail.engineTorqueCn}} <span class="spec-val-unit"></span><i class="iconfont">&#xe643;</i></span>
              </li>
              <li>
                <span class="spec-key">{{$t('searchDetail.exterior')}}：</span>
                <span class="spec-val">{{locale == 'en' || detail.exteriorColorCn == '' || detail.exteriorColorCn == null ? detail.exteriorColor : detail.exteriorColorCn}}</span>
              </li>
              <li class="spec-min-w200">
                <span class="spec-key">{{$t('searchDetail.interior')}}：</span>
                <span class="spec-val">{{locale == 'en' || detail.interiorColorCn == '' || detail.interiorColorCn == null ? detail.interiorColor : detail.interiorColorCn}}</span>
              </li>
              <!-- 座位 -->
              <li>
                <span class="spec-key">{{$t('searchDetail.seats')}}：</span>
                <span class="spec-val">{{detail.seats}}</span>
              </li>
              <!-- 手數 -->
              <li>
                <span class="spec-key">{{$t('searchDetail.previousowners')}}：</span>
                <span class="spec-val">{{detail.previousOwners}}</span>
              </li>
              <!-- 里程 -->
              <li>
                <span class="spec-key">{{$t('searchDetail.mileage')}}：</span>
                <span class="spec-val">
                  {{detail.mileage}} <span class="spec-val-unit">{{$t('search.car.km')}}</span>
                  <!-- <i class="iconfont">&#xe60e;</i> -->
                </span>
              </li>
              <!-- <li class="spec-min-w200">
									<span class="spec-key">Telephone：</span>
									<span class="spec-val">02-2998-8866</span>
								</li>
								<li class="spec-full-width">
									<span class="spec-key">Address：</span>
									<a href="javasript:;" target="_blank" class="spec-val">新北市新莊區中正路54號</a>
								</li> -->
            </ul>
          </div>
          <!-- <el-popover
						ref="popover1"
						popper-class="popper-my"
						placement="bottom"
						width="200"
						trigger="hover"
						content="貸款試算頭款20%, 期數36期, 利率3.75%。">
					</el-popover> -->

          <el-popover ref="popover2"
                      :popper-class="$t('language.name') == 'English' ? 'popper-my normal' : 'popper-my'"
                      placement="bottom"
                      width="200"
                      trigger="hover"
                      :content="$t('searchDetail.popover2')">
          </el-popover>

          <el-popover ref="popover3"
                      :popper-class="$t('language.name') == 'English' ? 'popper-my normal' : 'popper-my'"
                      placement="bottom"
                      width="200"
                      trigger="hover"
                      :content="$t('searchDetail.popover2')">
          </el-popover>

          <div class="col-md-8 col-lg-8"
               v-show="detail.feature == '' || detail.feature == null ? false : true">
            <h4>{{$t('searchDetail.highlights')}}</h4>
            <div class="listing-desc"
                 v-html="locale == 'en' || detail.featureCn == '' || detail.featureCn == null ? detail.feature : detail.featureCn"></div>
          </div>
          <div class="col-sm-12 col-xs-12">
            <div class="listing-btn">
              <div class="button-group">

                <!-- <a class="button button-secondary"
                   href="tel:85222910000"
                   @click="callus">
                  <span class="button_text"
                        @click="callus">
                    {{call}}
                    <i class="iconfont">&#xe602;</i>
                  </span>
                </a> -->

                <button class="button button-primary"
                        type="button"
                        @click="instantQuery">
                  <i class="icon-whatsapp"></i>
                  <span class="button_text"
                        :style="locale == 'en' ? 'line-height: normal;margin-left: 8px;': 'margin-left: 8px;'"
                        v-html="$t('searchDetail.instantQuery')">
                  </span>
                </button>

                <button class="button button-primary"
                        type="button"
                        @click="contactus">
                  <span class="
                        button_text"
                        :style="locale == 'en' ? 'line-height: normal': ''"
                        v-html="$t('searchDetail.contactus')">
                    <!-- <i class="iconfont">&#xe6bd;</i> -->
                  </span>
                </button>

                <div class="my-md-none"></div>
                <!-- <div v-if="detail.pdfUrl == '' || detail.pdfUrl == null ? false : true">
										<button class="button-round button-icon" type="button" @click="hangleDow(detail.id, detail.carStyleName)">
											<van-loading color="#dc3545" v-if="loadDownPdf"/>
											<i class="iconfont" v-if="!loadDownPdf">&#xe639;</i>	
										</button>
										<span class="button-icon-label">Download Specification</span>
									</div> -->

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="search-detail-calc">
			<div class="container">
				<form class="calc-box" action="">
					贷款计算
					<h4>Payment Estimation</h4>
					<div class="row justify-content-center align-items-end">
						<div class="col-xs-6 col-sm-4 box-s">
							<div class="aui-select aui-js-select aui-select-floating-label is-dirty">
								<select class="aui-select__input" name="deposit" v-model="calcDeposit" @change="changeCalc()">
									自備頭期款
									<option disabled class="aui-select__input-label" value="">Down Payment</option>
									<option value="0">0%</option>
									<option value="0.1">10%</option>
									<option value="0.2" selected>20%</option>
									<option value="0.3">30%</option>
									<option value="0.4">40%</option>
									<option value="0.5">50%</option>
								</select>
								<label class="aui-select__label">Down Payment</label>
								<span class="aui-select__focus-line"></span>
							</div>
							<div class="aui-select aui-js-select aui-select-floating-label is-dirty">
								<select class="aui-select__input" name="term" v-model="calcTerm" @change="changeCalc()">
									期数
									<option disabled class="aui-select__input-label" value="">Term</option>
									<option value="12" data-rate="3.75">12期</option>
									<option value="24" data-rate="3.75">24期</option>
									<option value="36" data-rate="3.75" selected>36期</option>
									<option value="48" data-rate="3.75">48期</option>
									<option value="60" data-rate="3.75">60期</option>
								</select>
								<label class="aui-select__label">Term</label>
								<span class="aui-select__focus-line"></span>
							</div>
						</div>

						<div class="col-xs-6 col-sm-4 box-s">
							<div class="aui-textfield aui-js-textfield aui-textfield-floating-label is-dirty">
								<div class="aui-textfield__field">
									<input class="aui-textfield__input" type="text" name="price" maxlength="10" :value="calcPrice | NumFormatIcon" readonly="">
									車價
									<label class="aui-textfield__label">Price (HK$)</label>
									<span class="aui-textfield__focus-line"></span>
								</div>
							</div>
																					
							<div class="aui-textfield aui-js-textfield aui-textfield-floating-label is-dirty">
								<div class="aui-textfield__field">
									<input class="aui-textfield__input" type="text" name="rate" maxlength="10" value="3.75%" readonly="">
									利率
									<label class="aui-textfield__label">Interest rate</label>  
									<span class="aui-textfield__focus-line"></span>
								</div>
							</div>
						</div>
						
						<div class="col-xs-12 col-sm-4 box-s">
							<div class="aui-textfield aui-js-textfield aui-textfield-floating-label is-dirty">
								预估月付额
									<h5>Estimated Monthly Payment</h5>
									<div class="aui-textfield__field">
											<input class="aui-textfield__input strong" type="text" name="monpay" maxlength="10" :value="calcMonpay" readonly="">
											<label class="aui-textfield__label"></label>
											<span class="aui-textfield__focus-line"></span>
									</div>
							</div>
						</div>

						<div class="col-sm-12  col-xs-12">
								<span class="aui-textfield__description">Customers can refer to the Loan confirmation letter for actual related information.</span>
						</div>
				</div>
				</form>
			</div>
		</div> -->

    <div class="search-listing-similar">
      <div class="container">
        <h3>{{$t('searchDetail.recommendation')}}</h3>
      </div>
      <div class="listing-similar">
        <div class="container">
          <div class="row no-row">
            <div class="list-item col-sm-4 col-md-4 col-lg-4"
                 v-for="(item, index) in similarList"
                 :key="index">
              <div class="row no-gutters">
                <div class="col-xs-12 col-sm-12 box-s">
                  <div class="item-l">
                    <a @click="onRouter(item)"
                       class="lazy"
                       v-lazy:background-image="url + item.carImgUrls[0]"
                       :key="item.id"
                       :alt="item.carBrandEn"></a>
                    <!-- <a @click="onRouter(item)"
                       class="lazys"
                       v-lazy:background-image="item.thumbnailUrls == null ? require('../../images/zanwu.gif') : url + item.thumbnailUrls[0]"></a> -->
                  </div>
                </div>
                <div class="col-xs-12 col-sm-12 box-s">
                  <div class="item-r">
                    <h3>
                      <a @click="onRouter(item)"
                         class="aui-button">{{locale == 'en' ? item.carBrandEn + ' ' + item.carStyleEn + ' ' + item.year : item.carBrand + ' ' + item.carStyleName + ' ' + item.year}}
                      </a>
                      <i class="iconfont red">&#xe62e;</i>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import Swiper from "swiper"
import { reqGetCarInventoryList, reqDownLoadPdf } from "../../untils/api"
import { Toast } from 'vant'

export default {
  name: "Detail",
  inject: ['reload'],
  data () {
    return {
      locale: this.$store.state.locale,
      w: window.innerWidth,
      htmlTitle: '',
      nowDate: '',
      loadDownPdf: false,
      baseURL: this.$store.state.baseURL,
      url: this.$store.state.baseURL + '/otherusedcar/',
      call: '',
      calcPrice: '',   //車價
      calcDeposit: 0.2,  //自備頭期款
      calcTerm: 36,   //期數
      calcRate: 0.0375,  //利率
      calcMonpay: '-',  //預估月付額
      tableData: [],
      detail: {
        // carList: [
        // 	{img: require('../../picture/o1.jpg'), alt: '1'},
        // ],
      },
      promotionsList: [],
      similarList: [],
      currentPage: 1, //当前页
      total: 0,  //一共多少条数据
    };
  },
  created () {
    // window.addEventListener("beforeunload",()=>{
    //   this.$store.commit('$_setCar', item)
    // })
  },
  mounted () {
    let that = this
    let data = {
      currentPage: 1, //当前页
      pageSize: that.total,  //一页展示多少
    }
    // that.promotions()
    that.call = that.$t('searchDetail.callus')

    if (that.$route.params.id == that.$store.state.car.id) {
      that.detail = that.$store.state.car
      that.calcPrice = that.$store.state.car.currentPrice
      that.carInventoryList(data)
      setTimeout(() => {
        that.swiper()
      }, 200)
    } else {
      that.carInventoryList(data)
      // that.tableData.forEach(val=>{
      // 	if(val.id == that.$route.params.id) {
      // 			that.detail = val
      // 			that.calcPrice = val.currentPrice
      // 	}
      // })
    }

    PubSub.subscribe('locale', (msg, data) => {
      if (data.locale != '') {
        this.reload()
        this.$validator.locale = this.$store.state.locale
      }
    })

    that.addDate()
  },
  methods: {
    //底下三个模块，替换中英文
    // promotions () {
    //   let that = this
    //   that.promotionsList = this.$t('searchDetail.promotions')
    // },
    // 当前时间
    addDate () {
      let nowDate = new Date();
      let dateDate = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
      }
      this.nowDate = dateDate.year + '' + dateDate.month + '' + dateDate.date
    },
    onRouter (item) {
      this.$store.commit('$_setCar', item)
      this.reload()
      this.$router.push({ name: 'Detail', params: { id: item.id } })
      // window.open(routeUrl.href, '_blank')
    },
    //下载
    hangleDow (id, carStyleName) {
      if (this.loadDownPdf == false) {
        this.loadDownPdf = true
        let data = {
          inventoryId: id
        }
        reqDownLoadPdf(data).then(res => {
          this.loadDownPdf = false
          let url = window.URL.createObjectURL(new Blob([res]))
          let link = document.createElement('a')
          this.htmlTitle = carStyleName + '-' + this.nowDate + '.pdf'
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', this.htmlTitle)    // 自定义下载文件名（如exemple.txt）
          document.body.appendChild(link)
          link.click()
        })
      }
    },
    // 贷款计算
    changeCalc () {
      this.calcMonpay = this.calcPrice
    },
    async carInventoryList (data) {
      let that = this
      let res = await reqGetCarInventoryList(data)
      if (res.code == 200) {
        let data = res.data.carInventoryList
        that.total = data.total
        that.tableData = data.list
        that.tableData.forEach((val, i) => {
          // that.tableData[i].currentPrice = val.currentPrice
          if (val.thumbnailUrls != null) {
            that.tableData[i].currentPrice = val.currentPrice
            that.tableData[i].thumbnailUrls = val.thumbnailUrls.split(';')
            that.tableData[i].carImgUrls = val.carImgUrls.split(';')
            that.tableData[i].thumbnailUrls.forEach((valList, imgIndex) => {
              if (valList == '') {
                that.tableData[i].thumbnailUrls.splice(imgIndex, 1)
              }
            })
            that.tableData[i].carImgUrls.forEach((valList2, imgIndex2) => {
              if (valList2 == '') {
                that.tableData[i].carImgUrls.splice(imgIndex2, 1)
              }
            })
          } else {
            that.tableData[i].carImgUrls = []
          }

          if (that.$route.params.id != that.$store.state.car.id) {
            if (val.id == that.$route.params.id) {
              that.detail = that.tableData[i]
              that.calcPrice = that.tableData[i].currentPrice
              that.$store.commit('$_setCar', that.tableData[i])

              setTimeout(() => {
                that.swiper()
              }, 300)
            }
            setTimeout(() => {
              if (val.id != this.$route.params.id && JSON.stringify(this.detail) == "{}") {
                that.$router.push({ path: '/' })
                Toast({ message: 'No vehicle present', duration: 2000 })
                return false
              }
            }, 300)

          }

          if (that.similarList.length < 3) {
            if (val.carBrandId == that.detail.carBrandId && val.id != that.detail.id) {
              that.similarList.push(that.tableData[i])
              // console.log('that.similarList', that.similarList)
            }
          }

        })


        // if (this.$route.params.id != this.$store.state.car.id) {
        // 	this.tableData.forEach((valTableData, i) => {
        // 		if (valTableData.id == this.$route.params.id) {
        // 			this.detail = valTableData
        // 			this.calcPrice = valTableData.currentPrice
        // 			this.$store.commit('$_setCar', valTableData)
        // 		}
        // 		setTimeout(() => {
        // 			this.$nextTick(()=> {
        // 				if (valTableData.id != this.$route.params.id && JSON.stringify(this.detail) == "{}") {
        // 						this.$router.push({path:'/'})
        // 					Toast({message: 'No vehicle present', duration: 2000})
        // 					return false
        // 				}
        // 			})
        // 		},300)
        // 	}) 
        // }
      }
    },
    swiper () {
      new Swiper('.swiper', {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        zoom: true,
        initialSlide: 0,
        loop: true,
        slidesPerView: 'auto',
        // loopedSlides: 2.7,
        centeredSlides: true,
        navigation: {
          nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: 'my-button-disabled', //前进后退按钮不可用时的类名。
          hiddenClass: 'my-button-hidden', //按钮隐藏时的Class
        },
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'my-bullet-li',//需设置.my-bullet-li样式
          hideOnClick: false, //默认分页器会一直显示。这个选项设置为true时点击Swiper会隐藏/显示分页器。
          clickable: true, //此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
        }
      })
    },
    callus () {
      return this.call = '+852 23686809'
    },
    contactus () {
      this.$router.push({ name: 'ContactUs' })
    },
    instantQuery () {
      let url = 'https://api.whatsapp.com/send?phone=85270728072&text=你好！想查詢二手車資料'
      window.open(url, "_blank")
    }
  },
  components: {},
  watch: {
    similarList: {
      handler (newValue, oldValue) {
        this.$nextTick(() => {
          /*现在数据已经渲染完毕*/
          if (this.similarList.length < 3) {
            this.tableData.forEach(val => {
              if (val.carSeriesId == this.detail.carSeriesId && val.carModelId != this.detail.carModelId && val.id != this.detail.id) {
                if (this.similarList.length < 3) {
                  newValue.push(val)
                }
              }
            })
          }
        })
      },
      deep: true
    }
  }
};
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>
.box-s {
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
  box-sizing: border-box;
  float: left;
  display: block;
}

.col-xs-6 {
  width: 49%;
}

.col-6 {
  width: 49%;
}

label {
  margin: 0;
}

a {
  cursor: pointer;
}

[type=reset], [type=submit], button, html [type=button] {
  -webkit-appearance: none;
}

.row {
  // display: -webkit-flexbox;
  // display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
}

.my-md-none {
  width: 100%;
  margin-top: 20px;
}

.search-detail {
  // 轮播
  .search-detail-swiper {
    width: 100%;
    position: relative;

    .swiper-container {
      cursor: pointer;
    }

    .swiper-container >>> .swiper-slide {
      width: 30%;
      // max-height: 580px;
      opacity: 0.5;
      -webkit-transition: opacity 0.4s ease-in-out;
      -o-transition: opacity 0.4s ease-in-out;
      transition: opacity 0.4s ease-in-out;
      margin-right: 6px;
      box-sizing: border-box;

      .lazys, .lazy {
        width: 100%;
        padding-top: 75%;
        background: #eee;
        display: block;
        background-size: cover;
        // opacity: 0;
        transition: opacity 0.4s ease;
      }

      &.swiper-slide-active {
        .lazy {
          opacity: 1;
        }
      }
    }

    // 选中
    .swiper-container >>> .swiper-slide-active {
      opacity: 1;
      color: #fff;
    }

    .swiper-button-prev {
      left: 8px;
    }

    .swiper-button-next {
      right: 8px;
    }

    .swiper-button-next, .swiper-button-prev {
      padding: 0 6px;
      width: auto;
      height: 46px;
      line-height: 46px;
      opacity: 0.9;
      color: #fff;
      background-image: none;
      background: rgba(0, 0, 0, 0.1);
      display: flex;
      cursor: pointer;
      -webkit-transition: all 0.2s ease-in-out;
      -o-transition: all 0.2s ease-in-out;
      transition: all 0.2s ease-in-out;

      &::before {
        font-size: 20px;
      }

      &:hover {
        background: rgba(0, 0, 0, 0.2);
        opacity: 1;
      }
    }

    .my-bullet {
      width: 100%;
      height: 20px;
      position: absolute;
      bottom: 0;
      z-index: 99;
      display: flex;
      justify-content: center;
    }

    .my-bullet >>> .my-bullet-li {
      width: 30px;
      height: 10px;
      float: left;
      margin: 0px 2px;
      background: rgba(102, 102, 102, 0.5);
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
      -webkit-backface-visibility: visible;
      -webkit-transition: background-color 0.2s ease;
      -o-transition: background-color 0.2s ease;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: rgba(255, 255, 255, 0.8);
      }
    }

    .my-bullet >>> .swiper-pagination-bullet-active {
      background-color: rgba(255, 255, 255, 0.8);
      opacity: 1;
    }

    &:hover {
      .swiper-button-next, .swiper-button-prev {
        opacity: 1;
      }
    }
  }

  // 数据表
  .search-detail-data {
    padding: 30px 0 100px;

    h1 {
      margin: 20px 0 6px;
      font-family: 'AttenNewRegular', 'Source Han Sans CN';
      font-weight: 700;
    }

    h4 {
      margin: 32px 0 10px;
    }

    .listing-specs {
      overflow: auto;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      list-style: none;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      -webkit-box-align: end;
      -ms-flex-align: end;
      align-items: flex-end;
      margin: 0;
      padding: 0;

      li {
        -webkit-box-flex: 1;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        width: 50%;
        margin: 0;
        padding: 0.5em 0.5em 0.5em 0;
        font-size: 14px;
        line-height: 1.2;
        border-bottom: 1px solid #ddd;

        &.spec-min-w320 {
          min-width: 320px;
        }

        &.spec-min-w300 {
          min-width: 300px;
        }

        &.spec-min-w200 {
          min-width: 200px;
        }

        .alt-price {
          white-space: nowrap;
          font-size: 12px;
          color: #dc3545;
          cursor: pointer;
        }

        .spec-val {
          .spec-val-unit {
            font-size: 12px;
            color: #555;
          }

          i {
            font-size: 14px;
          }
        }

        .original {
          color: #999;
          text-decoration: line-through;
          text-decoration-line: line-through;
          text-decoration-color: #999;
          -moz-text-decoration-color: #999;
        }
      }
    }

    .listing-btn {
      margin-top: 30px;

      .button-group {
        -ms-display: -ms-inline-flexbox;
        display: inline-flex;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
        -ms-flex-align: center;
        align-items: center;
        vertical-align: top;

        .button {
          display: flex;
          font-family: inherit;
          font-size: 16px;
          font-weight: 400;
          text-align: center;
          text-decoration: none;
          white-space: normal;
          vertical-align: middle;
          border: 1px solid transparent;
          background: 0 0;
          border-radius: 0;
          cursor: pointer;
          position: relative;
          padding: 10px 44px;
          margin: 0 8px 6px 0;
          outline: 0;
          -ms-flex: 1 1 auto;
          flex: 1 1 auto;
          transition: all 0.3s cubic-bezier(0.75, 0.02, 0.5, 1);
          -webkit-tap-highlight-color: transparent;
          -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

          &:first-child {
            padding: 10px 30px;
          }

          &.button-primary {
            // border-color: #000;
            // background-color: #000;
            // color: #fff;
            // stroke: #fff;
            // fill: #fff;
            background-color: #fff;
            color: #000;
            stroke: #000;
            fill: #000;
            border-color: #999;

            &:hover, &:active {
              box-shadow: 0 2px 6px #ccc;
              // border-color: #333333;
              // background-color: #333333;
              // color: #fff;
            }

            .icon-whatsapp {
              display: block;
              width: 34px;
              height: 40px;
              cursor: pointer;
              background: url('../../images/i-whatsapp.png') no-repeat center center;
              background-size: contain;
            }
          }

          &.button-secondary, &.button-secondary:visited {
            border-color: #000;
            background-color: #fff;
            color: #000;
            stroke: #000;
            fill: #000;
          }

          .button_text {
            line-height: 40px;
            display: inline-block;
            position: relative;
            text-align: left;
          }
        }

        .button-round {
          width: 45px;
          height: 45px;
          padding: 0;
          border: 1px solid #000;
          border-radius: 50%;
          background: transparent;
          margin: 0 6px 6px 8px;
          -ms-flex: 0 0 auto;
          flex: 0 0 auto;

          &.button-icon-secondary {
            color: #dc3545;
            border-color: #dc3545;
          }

          i {
            font-size: 18px;
          }
        }

        .button-icon-label {
          font-size: 14px;
          margin-right: 10px;
        }
      }
    }
  }

  // 计算
  .search-detail-calc {
    margin-top: 20px;

    h5 {
      margin: 0;
      font-size: 16px;
    }

    .calc-box {
      border: 1px solid #ddd;
      background: #f3f3f3;
      padding: 14px;

      .justify-content-center {
        -ms-flex-pack: center !important;
        justify-content: center !important;
      }

      .align-items-end {
        -ms-flex-align: end !important;
        align-items: flex-end !important;
      }

      .row {
        margin-right: -15px;
        margin-left: -15px;
      }
    }
  }

  // 相近列表
  .search-listing-similar {
    margin-bottom: 30px;

    .listing-similar {
      padding-top: 10px;

      .no-row {
        // margin-right: -15px;
        // margin-left: -15px;
      }

      .list-item {
        margin-bottom: 20px;

        .no-gutters {
          margin-right: 0;
          margin-left: 0;
        }

        .item-l {
          position: relative;
          background: #f9f9f9;

          a {
            display: block;
            width: 100%;
            padding-top: 75%;
            background: #eee 50% 50% no-repeat;
            background-size: cover;
          }
        }

        .item-r {
          h3 {
            display: flex;
            flex-direction: row;
            margin: 3px 0;
            font-size: 16px;
            line-height: 26px;

            i {
              position: relative;
              left: 0;
              top: -1px;
              transition: left 0.2s ease;
            }

            &:hover {
              i {
                left: 4px;
              }
            }

            a {
              font-weight: 400;

              &:hover {
                color: #000;
              }
            }
          }

          .item-specs {
            margin: 0;
            padding: 0;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -ms-flex-wrap: wrap;
            flex-wrap: wrap;
            line-height: 18px;

            li {
              width: 100%;
            }
          }

          .aui-button {
            color: inherit;
            display: inline-block;
            white-space: nowrap;
            overflow: hidden;
            padding-right: 4px;
            -o-text-overflow: ellipsis;
            text-overflow: ellipsis;
            transition: all 0.3s cubic-bezier(0.75, 0.02, 0.5, 1);
            -webkit-tap-highlight-color: transparent;
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

            &:hover {
              color: #4c4c4c;
              stroke: #4c4c4c;
              fill: #4c4c4c;
            }

            .aui-button__text {
              display: inline-block;
              position: relative;
              font-family: inherit;
              font-size: 12px;
              font-weight: 300;
              text-align: left;
            }
          }
        }
      }
    }
  }

  // 表单
  form {
    .aui-select__focus-line, .aui-textfield__focus-line {
      display: block;
      position: relative;
      width: 100%;
      margin-top: -2px;
      height: 1px;
      background: rgba(0, 0, 0, 0.8);
      opacity: 0;
      transition-property: opacity, background;
      transition-duration: 0.25s;
    }

    .aui-select {
      margin: 0;
      margin-top: 15px;
      font-size: 16px;
      display: block;
      position: relative;
      box-sizing: border-box;
      padding-top: 12px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.8);

      &::after {
        font-family: 'iconfont' !important;
        font-size: 24px;
        color: #888;
        content: '\e689';
        display: block;
        position: absolute;
        top: 23px;
        right: 0;
        width: 25px;
        height: 25px;
        transform: translateY(-50%);
        transition: background 0.25s linear;
        pointer-events: none;
      }

      &:hover .aui-select__input {
        border-color: rgba(0, 0, 0, 0.8);
      }

      &.is-dirty {
        // margin-top: 4px;
        .aui-select__input {
          color: #333;
        }
      }
    }

    .aui-select__input {
      display: block;
      margin: 0;
      padding: 10px 28px 10px 0;
      width: 100%;
      min-height: 42px;
      font-size: inherit;
      font-weight: 400;
      line-height: inherit;
      color: rgba(0, 0, 0, 0.6);
      background: 0 0;
      border: none;
      border-radius: 0;
      box-shadow: none;
      transition: color, border;
      transition-duration: 0.25s;
      transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      outline: 0;

      &:focus~.aui-select__focus-line {
        opacity: 1;
      }
    }

    .aui-select__label {
      display: block;
      position: absolute;
      top: 18px;
      right: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      color: rgba(0, 0, 0, 0.6);
      font-size: inherit;
      font-weight: 400;
      text-align: left;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      transition-property: top, font-size, color, opacity;
      transition-duration: 0.25s;
      transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
      opacity: 0;
      pointer-events: none;
    }

    .aui-select.is-focused .aui-select__input {
      outline: 0;
      box-shadow: none;
      border-color: rgba(0, 0, 0, 0.8);
    }

    .aui-select.aui-select-floating-label .aui-select__label {
      top: 0;
      font-size: 12px;
      opacity: 1;
    }

    // 第二横，下拉选择框
    .aui-fieldset {
      margin: 0;
      padding: 0;
      border: none;
      line-height: auto;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.6);
      box-sizing: border-box;

      .aui-fieldset__legend {
        font-size: 16px;
        font-weight: 700;
        color: #333;
        padding-top: 20px;
      }

      .aui-fieldset__fields {
        display: flex;

        .aui-fieldset__field {
          flex: 1 1 auto;
          margin-right: 25px;
          margin-bottom: 25px;

          &:nth-of-type(2) {
            margin-right: 0;
          }
        }
      }
    }

    // 第三横，文本 与 文选框
    .aui-textfield {
      margin: 0;
      padding: 0;
      margin-top: 15px;
      display: block;
      position: relative;
      font-size: 16px;
      line-height: auto;
      stroke: #333;
      box-sizing: border-box;

      // 文选框
      &.aui-textfield-multiline {
        padding-top: 20px;
        transition-property: padding;
        transition-duration: 0.25s;
        transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

        .aui-textfield__field {
          padding-top: 8px;
          border: 1px solid rgba(0, 0, 0, 0.3);

          .aui-textfield__input {
            padding-top: 8px;
            padding-left: 10px;
            padding-right: 10px;
            height: 99px;
          }

          .aui-textfield__label {
            top: 10px;
            left: 10px;
          }
        }
      }

      &.is-dirty {
        // margin-top: 4px;
        .aui-textfield__field {
          padding-top: 12px;
          border-bottom-color: rgba(0, 0, 0, 0.8);

          .aui-textfield__input {
            // padding-top: 0;
            outline: 0;
            box-shadow: none;
          }

          .aui-textfield__label {
            top: 0;
            font-size: 12px;
            opacity: 1;
          }
        }
      }

      .aui-textfield__field {
        padding-top: 12px;
        position: relative;
        border-bottom: 1px solid rgba(0, 0, 0, 0.3);
        transition-property: border, padding;
        transition-duration: 0.25s;
        transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

        &:hover {
          border-bottom-color: rgba(0, 0, 0, 0.8);
        }

        .aui-textfield__input {
          display: block;
          margin: 0;
          padding: 10px 0;
          width: 100%;
          min-height: 40px;
          font-size: inherit;
          font-weight: 400;
          line-height: inherit;
          text-align: left;
          color: rgba(0, 0, 0, 0.6);
          background: 0 0;
          border: none;
          transition: color 0.25s cubic-bezier(0.75, 0.02, 0.5, 1);
          resize: none;
          outline: 0;
          border-radius: 0;

          &.strong {
            font-family: 'AttenNewRegular', 'Source Han Sans CN';
            font-size: 20px;
            font-weight: 700;
          }

          &:focus~.aui-textfield__focus-line {
            opacity: 1;
          }
        }

        .aui-textfield__label {
          display: block;
          position: absolute;
          top: 24px;
          left: 0;
          width: 100%;
          color: rgba(0, 0, 0, 0.6);
          font-size: 16px;
          font-weight: 400;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          pointer-events: none;
          transition-property: top, font-size, color, opacity;
          transition-duration: 0.25s;
          transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
          pointer-events: none;
        }
      }

      &.is-dirty .aui-textfield__field .aui-textfield__input {
        color: #333;
      }
    }

    .aui-textfield.aui-textfield-floating-label .aui-textfield__label {
      top: 0;
      font-size: 12px;
      opacity: 1;
    }

    // 第四横，多选按钮
    .aui-checkbox {
      display: inline-block;
      position: relative;
      font-weight: 400;
      height: 30px;
      line-height: 30px;
      margin-top: 10px;
      padding-left: 50px;
      margin-right: 16px;
      color: #333;
      box-shadow: 0 0 3px 3px rgba(255, 255, 255, 0.2);
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
      transition: color, border;
      transition-duration: 0.25s;
      transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

      &:hover {
        .aui-checkbox__label {
          color: rgba(0, 0, 0, 1);
        }

        .aui-checkbox__box {
          border-color: rgba(0, 0, 0, 0.8);
        }
      }

      .aui-checkbox__label {
        font-size: 16px;
      }

      .aui-checkbox__input {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        position: absolute;
        width: 0;
        height: 0;
        overflow: hidden;
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        opacity: 0;
        z-index: -1;

        &:focus~.aui-checkbox__box {
          box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.1);
        }
      }

      .aui-checkbox__box {
        display: inline-block;
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 0;
        width: 30px;
        height: 30px;
        border: 1px solid rgba(0, 0, 0, 0.5);
        transition: box-shadow 0.15s linear, border 0.15s linear;
        cursor: pointer;
        pointer-events: none;
        z-index: 1;

        .aui-checkbox__tick {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          width: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          color: rgba(0, 0, 0, 0.5);
          transform: translate(-50%, -50%);
          opacity: 0;
          transition: opacity 0.15s cubic-bezier(0.75, 0.02, 0.5, 1);
          pointer-events: none;
        }

        &.is-checked .aui-checkbox__tick {
          opacity: 1;
        }
      }
    }

    // 第六、七横，单选按钮
    .aui-fieldset-radios {
      .aui-fieldset__fields {
        .aui-fieldset__field {
          -ms-flex: 0 1 auto;
          flex: 0 1 auto;

          .aui-radio {
            display: inline-block;
            position: relative;
            font-weight: 400;
            height: 30px;
            line-height: 30px;
            margin-top: 10px;
            padding-left: 50px;
            margin-right: 16px;
            color: #333;
            cursor: pointer;
            -webkit-tap-highlight-color: transparent;
            -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

            &.is-checked {
              .aui-radio__box {
                .aui-radio__tick {
                  background: rgba(0, 0, 0, 0.8);
                  transform: translate(-50%, -50%) scale(0.7, 0.7);
                }
              }
            }

            &:hover {
              color: #000;

              .aui-radio__box {
                border-color: #000;
              }

              .aui-radio__tick {
                transform: translate(-50%, -50%) scale(0.5 0.8, 0.5 0.8);
              }
            }

            &.is-dirty {
              color: #333;
            }

            .aui-radio__input {
              -webkit-appearance: none;
              -moz-appearance: none;
              appearance: none;
              position: absolute;
              width: 0;
              height: 0;
              overflow: hidden;
              margin: 0;
              padding: 0;
              border: 0;
              outline: 0;
              opacity: 0;
              z-index: -1;

              &:focus~.aui-radio__box {
                box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.1);
              }
            }

            .aui-radio__label {
              font-size: 16px;
            }

            .aui-radio__box {
              display: inline-block;
              overflow: hidden;
              position: absolute;
              top: 0;
              left: 0;
              width: 30px;
              height: 30px;
              line-height: 30px;
              border: 1px solid rgba(0, 0, 0, 0.5);
              border-radius: 50%;
              transition: box-shadow 0.15s linear, border 0.15s linear;
              cursor: pointer;
              pointer-events: none;
              z-index: 1;

              .aui-radio__tick {
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                width: 20px;
                height: 20px;
                line-height: 20px;
                transform: translate(-50%, -50%) scale(0.5, 0.5);
                border-radius: 50%;
                background: rgba(0, 0, 0, 0.1);
                transition: transform 0.15s cubic-bezier(0.75, 0.02, 0.5, 1), background 0.15s linear;
                pointer-events: none;
              }
            }
          }
        }
      }
    }

    .aui-textfield__description {
      display: block;
      margin-top: 8px;
      font-size: 12px;
      line-height: 30px;
      color: rgba(0, 0, 0, 0.5);
      transition: color 0.25s linear;
    }
  }
}

.pdf {
  font-size: 14px;

  li {
    font-size: 15px !important;
    line-height: 1.35;
  }
}

.img-list {
  ul {
    overflow: hidden;

    li {
      width: 50%;
      height: 400px;
      float: left;
      padding: 6px;
      box-sizing: border-box;

      &:nth-of-type(n+3) {
        width: 25%;
        height: 200px;
      }

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

@media (max-width: 1584px) {
  h1 {
    font-size: 31px;
  }
}

@media (max-width: 1264px) {
  h1 {
    font-size: 26px;
  }
}

@media (max-width: 740px) {
  h1 {
    font-size: 22px;
  }
}

@media (min-width: 780px) {
  .search-detail {
    .my-md-none {
      display: none;
    }

    .search-detail-swiper {
      .swiper-button-next, .swiper-button-prev {
        width: 34px;
        height: 80px;
        line-height: 80px;

        &::after {
          font-size: 24px;
        }
      }
    }
  }
}

@media (max-width: 580px) {
  .visible-xs {
    display: none !important;
  }

  .hidden-xs {
    display: block !important;
  }
}

@media (max-width: 480px) {
  .search-detail {
    .search-detail-swiper {
      .swiper-container >>> .swiper-slide {
        width: 100%;
      }
    }

    .search-detail-data {
      h1 {
        font-size: 21px;
      }

      .listing-btn {
        .button-group {
          width: 100%;
          display: flex;

          .button {
            padding: 10px 10px;
            margin: 0;
            width: 48%;
            font-size: 15px;

            &:first-child {
              padding: 10px 14px;
            }

            &.button-primary {
              .icon-whatsapp {
                width: 54px;
              }
            }

            .button_text {
              width: 100%;
              text-align: center;
            }

            &:first-of-type {
              margin-right: 1.5%;
            }

            &:last-of-type {
              margin-left: 1.5%;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Garage/Detail.vue